import { get } from '../utils/api'

export const fetchProductDetailData = async (prdSeq, idx) => {

  try {
    const prdListResponse = await get(`/product/alist?idx=${idx}`);

    const imageResponse = await get(`/product/img?idx=${prdSeq}`);
    
    const detailResponse = await get(`/product/detail?idx=${prdSeq}`);

    const specResponse = await get(`/product/spec?idx=${prdSeq}`);

    const fileResponse = await get(`/product/file?idx=${prdSeq}`);

    const prdListInfo = prdListResponse.map(item => ({
      INFO_SEQ: item.INFO_SEQ,
      INFO_IMG_PATH: item.INFO_IMG_PATH
    }));

    const images = imageResponse.map(row => row.IMG_PATH);

    const files = fileResponse.map(item => item);

    const headerText = specResponse.map(row => row.SPEC_NAME);

    const contentText = specResponse.map(row => row.SPEC_DESCRIPTION);

    return { 
      title: detailResponse[0].DETAIL_NAME,
      content: detailResponse[0].DETAIL_DESCRIPTION,
      files: files,
      images: images,
      th: headerText,
      td: contentText,
      prdListInfo: prdListInfo,
    };
  } catch (error) {
    console.log(error);
    return [];
  }
}